import { useState } from "react";
import { sendReportToServer } from '../../utils/error/reporter';
import { enqueueLocalReport } from '../../utils/error/queue';
import { Button, Col, FloatingLabel, FormControl, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row, Spinner } from "react-bootstrap";
import { useAuthState } from "../../context/AuthContext";

const ErrorReportModal = ({ error, info, show, onClose }) => {
    const { user } = useAuthState();
    const [desc, setDesc] = useState("");
    const [sending, setSending] = useState(false);
    const [message, setMessage] = useState(null);

    async function handleSend() {
        setSending(true);
        // collect last console messages
        const consoleLogs = window.__recentConsoleLogs || [];

        const payload = {
            user_id: user?.id || null,
            description: desc,
            error: {
                message: error?.message || null,
                stack: error?.stack || (info && info.componentStack) || null,
            },
            route: window.location.pathname,
            user_agent: navigator.userAgent,
            console_logs: consoleLogs,
            timestamp: new Date().toISOString(),
        };

        try {
            await sendReportToServer(payload);
            setMessage("Danke - Wir haben Ihre Meldung bekommen.");

        } catch (err) {
            console.error(err);
            enqueueLocalReport(payload);
            setMessage("Ihre Meldung ist gespeichert.")

        } finally {
            setSending(false);
        }
    }

    return (
        <Modal show={show} centered>
            <ModalHeader>
                <ModalTitle>Fehler melden</ModalTitle>
            </ModalHeader>
            <ModalBody>
                {message ?
                    <div className="text-center mt-4">
                        <b>{message}</b>
                    </div> :
                    <Row>
                        <Col>
                            <FloatingLabel label="Beschreiben Sie die Fehler">
                                <FormControl
                                    placeholder="Beschreiben Sie die Fehler"
                                    as="textarea"
                                    value={desc}
                                    onChange={e => setDesc(e.target.value)}
                                    style={{height: 200}}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                }
            </ModalBody>
            <ModalFooter className="d-flex">
                <Button variant={message? "energo":"warning"} onClick={onClose}>
                    {message? "Schließen": "Abbrechen"}
                </Button>
                <Button variant="energo" onClick={handleSend} disabled={sending} hidden={message}>
                    {sending ?
                        <Spinner animation="border" /> :
                        "Absenden"
                    }
                </Button>
            </ModalFooter>
        </Modal>
    )
}
export default ErrorReportModal;